import { Upload } from "antd";
import React from "react";

import api from "../../api";
import { BeforeUpload } from "./BeforeUpload";
import { useToast } from "../toast/toast";

const UploadGallery = ({ label, value, onChange }) => {
  const toast = useToast();
  const beforeUpload = BeforeUpload();

  const files = Array.isArray(value)
    ? value.map((url, idx) => ({
        uid: `${idx}`,
        name: `gallery-${idx}`,
        status: "done",
        url,
      }))
    : [];

  return (
    <div style={{ marginBottom: 12 }}>
      <p style={{ marginBottom: 6 }}>{label}</p>
      <Upload
        listType="picture-card"
        multiple
        fileList={files}
        beforeUpload={beforeUpload}
        onRemove={(file) => {
          const updated = files
            .filter((f) => f.uid !== file.uid)
            .map((f) => f.url);
          onChange(updated);
        }}
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            const formData = new FormData();
            formData.append("image", file);
            const res = await api.upload_image(formData);
            const url = res.data.url;
            onChange([...value, url]); // parent-д шинэ зураг нэмэх
            onSuccess(res, file);
            // toast("Зураг нэмэгдлээ", "success");
          } catch (err) {
            onError(err);
            toast("Алдаа гарлаа", "error");
          }
        }}
      >
        {files.length < 5 && "+ Зураг"}
      </Upload>
    </div>
  );
};

export default UploadGallery;
